var React = require('react');

function ArrowBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.872 12.316l3.982-6.072-3.982-6.05H8.528l2.618 4.312H0v3.498h11.146l-2.618 4.312z","fill":"currentColor","fillRule":"nonzero"}));
}

ArrowBtn.defaultProps = {"width":"16","height":"13"};

module.exports = ArrowBtn;

ArrowBtn.default = ArrowBtn;
